import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../lib/constants";
import SectionHeader from "./SectionHeader";

export const Services = () => {
    return (
        <section
            id="services"
            className="relative py-24 md:py-40 bg-ls-surface2/40 border-t border-b border-ls-ink/10"
            data-testid="services-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="mb-20 max-w-3xl">
                    <SectionHeader
                        eyebrow="Leistungen"
                        title={
                            <>
                                Zwei Disziplinen.{" "}
                                <em className="italic font-light">Ein</em>{" "}
                                Anspruch.
                            </>
                        }
                        intro="Wir bieten zwei eng verzahnte Leistungsbereiche – unabhängig oder als ganzheitliches Paket. Beides mit demselben Fokus: Ihr Erfolg."
                    />
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-ls-ink/10 border border-ls-ink/10">
                    {SERVICES.map((s, idx) => (
                        <motion.article
                            key={s.number}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{ duration: 0.8, delay: idx * 0.15 }}
                            className="group bg-ls-bg p-8 md:p-14 relative overflow-hidden hover:bg-ls-ink hover:text-ls-bg transition-colors duration-700"
                            data-testid={`service-card-${idx}`}
                        >
                            <div className="flex items-start justify-between mb-10">
                                <span className="text-xs uppercase tracking-[0.28em] font-sans text-ls-inkSoft group-hover:text-ls-bg/70 transition-colors">
                                    {s.number} / 02
                                </span>
                                <ArrowUpRight
                                    size={28}
                                    className="text-ls-ink group-hover:text-ls-bg transition-all duration-500 group-hover:rotate-12"
                                />
                            </div>

                            <h3 className="font-serif text-4xl md:text-5xl tracking-tight mb-3">
                                {s.title}
                            </h3>
                            <p className="font-serif italic text-lg md:text-xl text-ls-inkSoft group-hover:text-ls-bg/70 transition-colors mb-8">
                                {s.tagline}
                            </p>
                            <p className="text-base leading-relaxed font-sans mb-10 text-ls-inkSoft group-hover:text-ls-bg/85 transition-colors max-w-xl">
                                {s.description}
                            </p>

                            <ul className="space-y-3 border-t border-ls-ink/10 group-hover:border-ls-bg/15 pt-8 transition-colors">
                                {s.points.map((p, i) => (
                                    <li
                                        key={i}
                                        className="flex items-start gap-4 text-sm font-sans"
                                    >
                                        <span className="mt-2 w-4 h-px bg-current opacity-50 flex-shrink-0" />
                                        <span>{p}</span>
                                    </li>
                                ))}
                            </ul>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
